import * as React from 'react';
import { Box } from 'wix-style-react';
import { ToggleCard } from './cards/app-enabled-toggle/app-enabled-toggle';
import { TextAndDisplayContainer } from './cards/text-and-display';
import { PrivacyPolicyContainer } from './cards/privacy-policy';
import { AdvancedOptionsCard } from './cards/advanced-options-card/advanced-options-card';
import { AppContext } from '@src/context/store';
import { isAppEnabled } from '@src/context/selectors/ui-settings';
import * as css from './banner-settings.scss';
import { ReviewCookiePolicyRequirements } from './cards/review-cookie-policy-requirements/review-cookie-policy-requirements.container';

export const BannerSettingsComponent = () => {
  const store = React.useContext(AppContext);
  const appEnabled = isAppEnabled(store);
  const disabledProps = (appEnabled && {}) || { disabled: true, className: css.disabled };

  return (
    <>
      <ToggleCard />
      <fieldset style={{ padding: 0, margin: 0 }} {...disabledProps}>
        <Box marginBottom={'36px'}>
          <TextAndDisplayContainer />
        </Box>
        <Box marginBottom={'36px'}>
          <PrivacyPolicyContainer />
        </Box>
        {/* <Box marginBottom={'36px'}>*/}
        {/*  <AudienceContainer />*/}
        {/* </Box>*/}
        <Box marginBottom={'36px'}>
          <ReviewCookiePolicyRequirements />
        </Box>
        <Box marginBottom={'36px'}>
          <AdvancedOptionsCard />
        </Box>
      </fieldset>
    </>
  );
};
